import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./contexts/AuthContext";
import { SeriesProvider } from "./contexts/SeriesContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/Dashboard";
import Students from "./pages/Students";
import StudentDetail from "./pages/StudentDetail";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import AddStudent from "./pages/AddStudent";
import EditStudent from "./pages/EditStudent";
import Series from "./pages/Series";
import SeriesDetail from "./pages/SeriesDetail";
import EditSeries from "./pages/EditSeries";
import RunDetail from "./pages/RunDetail";
import AddSeries from "./pages/AddSeries";
import EditLab from "./pages/EditLab";
import Lab from "./pages/LabDetail";
import EditRun from "./pages/EditRun";
import AddLab from "./pages/AddLab";
import AddRun from "./pages/AddRun";
import Labs from "./pages/Labs";
import Runs from "./pages/Runs";
import Payments from "./pages/Payments";
import PaymentDetail from "./pages/PaymentDetail";
import AddPayment from "./pages/AddPayment";
import EditPayment from "./pages/EditPayment";
import ChangePassword from "./pages/ChangePassword";

function App() {
  return (
    <AuthProvider>
      <SeriesProvider>
        <Router>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#FFFFFF",
                color: "#1F2937",
                boxShadow:
                  "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                borderRadius: "0.375rem",
                padding: "0.75rem 1rem",
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/students" element={<Students />} />
              <Route path="/students/add" element={<AddStudent />} />
              <Route path="/students/:id" element={<StudentDetail />} />
              <Route path="/students/:id/edit" element={<EditStudent />} />
              <Route path="/series" element={<Series typeFilter="series" />} />
              <Route path="/events" element={<Series typeFilter="event" />} />
              <Route path="/camps" element={<Series typeFilter="camp" />} />
              <Route path="/runs" element={<Runs />} />
              <Route path="/labs" element={<Labs />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/payments/new" element={<AddPayment />} />
              <Route path="/payments/:id" element={<PaymentDetail />} />
              <Route path="/payments/:id/edit" element={<EditPayment />} />
              <Route path="/series/add" element={<AddSeries />} />
              <Route path="/series/:id" element={<SeriesDetail />} />
              <Route path="/series/:id/edit" element={<EditSeries />} />
              <Route path="/series/:seriesId/labs/new" element={<AddLab />} />
              <Route path="/series/:seriesId/labs/:labId" element={<Lab />} />
              <Route
                path="/series/:seriesId/labs/:labId/edit"
                element={<EditLab />}
              />
              <Route path="/series/:seriesId/runs/new" element={<AddRun />} />
              <Route path="/runs/:id" element={<RunDetail />} />
              <Route path="/runs/:id/edit" element={<EditRun />} />
              <Route path="/change-password" element={<ChangePassword />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </SeriesProvider>
    </AuthProvider>
  );
}

export default App;
